import { render, staticRenderFns } from "./colleges.vue?vue&type=template&id=e40030f8&scoped=true&"
import script from "./colleges.vue?vue&type=script&lang=js&"
export * from "./colleges.vue?vue&type=script&lang=js&"
import style0 from "./colleges.vue?vue&type=style&index=0&id=e40030f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40030f8",
  null
  
)

export default component.exports